import axios from "../../axios/axios-api";
import axiosCenso from "../../axios/axios-censo";
import axiosRoot from "../../axios/axios-root";

export const pegaListagemLeitos = ({ commit, rootGetters }, payload) => {
    commit("sessao/setLoading", true, { root: true })

    let token = rootGetters['sessao/getUsuario'].tokenAcesso

    let config = {
        headers: { Authorization: "Bearer " + token },
        params: {
          cnes: payload
        }
    }
    
    return axios
    .get("api/censo/listar", config)
    .then(resp => {
        commit("sessao/setLoading", false, { root: true })
        if (resp.data.status == true) commit("setListagemMapaLeitos", resp.data)
        if (resp.data.status == false) commit("setListagemMapaLeitos", resp.data)
    })
    .catch(error => {
        commit("sessao/setLoading", false, { root: true });
    });

};

export const listarOpcoesSelect = ({ commit, rootGetters }, payload) => {
    return axiosCenso
    .get("listarOpcao.php")
    .then(resp => {
        if (resp.data.status == true) commit("setOpcoesSelect", resp.data.dados)
    })
    .catch(error => {
      console.error(error)
    });

};

export const registraValidacao = ({ commit, rootGetters }, payload) => {
    commit("sessao/setLoading", true, { root: true })
    commit("sessao/setError", null, { root: true })

    let token = rootGetters['sessao/getUsuario'].tokenAcesso
    let header = { headers: { Authorization: "Bearer " + token }}

    return axios
    .post("/api/censo/registrarValidacao", payload, header)
    .then(resp => {
        commit("sessao/setLoading", false, { root: true })

        if (resp.data.status == false) commit("sessao/setError", {status: false, msg: resp.data.msg}, { root: true })
        if (resp.data.status == true) commit("sessao/setError", {status: true, msg: resp.data.msg}, { root: true })

    })
    .catch(error => {
        commit("sessao/setLoading", false, { root: true });
    });

};

export const acompanhar = ({ commit, rootGetters }, payload) => {
    commit("sessao/setLoading", true, { root: true })
    commit("sessao/setError", null, { root: true })

    let token = rootGetters['sessao/getUsuario'].tokenAcesso
    let header = { headers: { Authorization: "Bearer " + token }}

    return axios
    .post("/api/censo/acompanhar", payload, header)
    .then(resp => {
        commit("sessao/setLoading", false, { root: true })

        if (resp.data.status == false) commit("sessao/setError", {status: false, msg: resp.data.msg}, { root: true })
        if (resp.data.status == true) commit("sessao/setError", {status: true, msg: resp.data.msg}, { root: true })

    })
    .catch(error => {
        commit("sessao/setLoading", false, { root: true });
    });

};

export const atualizarDesconhecido = ({ commit, rootGetters }, payload) => {
    commit("sessao/setLoading", true, { root: true })
    commit("sessao/setError", null, { root: true })

    let config = {
        params: payload
    }

    return axiosRoot
    .get("/publico/controller/atualizarPacienteDesconhecido.php", config)
    .then(resp => {
        commit("sessao/setLoading", false, { root: true })

        if (resp.data.status == false) commit("sessao/setError", {status: false, msg: resp.data.msg}, { root: true })
        if (resp.data.status == true) commit("sessao/setError", {status: true, msg: resp.data.msg}, { root: true })

    })
    .catch(error => {
        commit("sessao/setLoading", false, { root: true });
    });

};


export const listarAcompanhamento = ({ commit, rootGetters }, payload) => {
    return axiosCenso
    .get("listarAcompanhamento.php?idInternacao=" + payload)
};

export const extracaoAcompanhamento = ({ commit, rootGetters }, payload) => {
    return axiosCenso
    .get("relatorios/listarAcompanhados.php?cnes=" + payload)
};

export const extracaoInternados = ({ commit, rootGetters }, payload) => {
    return axiosCenso
    .get("relatorios/listarInternados.php?cnes=" + payload)
};

// export const validaWebsocket = ({ commit, rootGetters }, payload) => {
//     let unidadeSelecionada = rootGetters['filtro/getUnidadeSelecionada'].cnes

//     if (unidadeSelecionada != null) unidadeSelecionada = unidadeSelecionada.toString()

//     if (unidadeSelecionada == payload.cnes) commit('updateLeito', payload.dados)
// };